import React from 'react';
import PropTypes from 'prop-types';
import { VaLink } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

// Details link for a claim/appeal card is routing agnostic. When the consumer
// passes an `onLinkClick` handler it's invoked with the click event and the link's href so the
// consumer can preventDefault and navigate however it sees fit. With no
// handler the link performs a plain full-page navigation.
export default function CardLink({ ariaLabel, href, onLinkClick }) {
  return (
    <VaLink
      aria-label={ariaLabel}
      className="vads-u-display--block vads-u-margin-top--2"
      href={href}
      onClick={onLinkClick ? e => onLinkClick(e, href) : undefined}
      text="Details"
      active
    />
  );
}

CardLink.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func,
};
